import { QueryClient } from "@tanstack/vue-query";

// sessionStorage key holding the persisted (stale-while-revalidate) query cache.
export const QUERY_CACHE_STORAGE_KEY = "camc.query-cache";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 60s: reopening a view or reloading within the
      // window serves the (persisted) cache with no refetch — the reload feels
      // instant. Mutations still invalidateQueries explicitly, so edits refresh
      // regardless of this; and after 60s a query is stale and revalidates
      // (stale-while-revalidate) rather than blocking.
      staleTime: 60 * 1000,
      // refetchInterval: false,
      refetchOnWindowFocus: false,
      // Keep query data long enough that a persisted cache restored on load
      // isn't garbage-collected before the page's components mount and read it
      // (stale-while-revalidate: show the cached copy, refetch behind it).
      cacheTime: 1000 * 60 * 60 * 24,
    },
  },
});
